<template>
    <b-modal id="image-modal"
             name="image-modal"
             :title="modalImageFilename"
             size="lg"
             hide-footer>
      <b-img fluid :src="modalImageUrl"></b-img>
    </b-modal>
</template>

<script>
  export default {
    name: 'PreviewImageModal',
    props: {
      modalImageFilename: String,
      modalImageUrl: String
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PreviewImageModal.vue?c42bda44